/**
 * ЗАМ.4 (`АРХ-Н39`, `oq-ММБ-328`): итоговое показание вводят с дисплея
 * счётчика — в кВт·ч, до сотых; база хранит Вт·ч целым. Перевод — целыми
 * числами, без дробной арифметики: `0,07` не превращается в 69,99… Вт·ч.
 * Запятая равна точке (слово РП 02.11).
 */

/** Предел столбца `INTEGER` в Вт·ч: 2 147 483 647 → 2 147 483,64 кВт·ч. */
const MAX_WH = 2147483647;

const KWH_PATTERN = /^(\d+)(?:[.,](\d{1,2}))?$/;

export const KWH_ERROR = "Укажите показание в кВт·ч, до двух знаков после запятой";

export type KwhParse = { ok: true; wh: number } | { ok: false; error: string };

/** «1234,56» / «1234.56» → 1 234 560 Вт·ч; иначе — ошибка с текстом для формы. */
export function parseKwhToWh(text: string): KwhParse {
  const match = KWH_PATTERN.exec(String(text ?? "").trim());

  if (!match) return { ok: false, error: KWH_ERROR };

  const whole = match[1].replace(/^0+(?=\d)/, "");
  // Больше 7 цифр целой части — заведомо за пределом столбца.
  if (whole.length > 7) return { ok: false, error: KWH_ERROR };

  const hundredths = Number((match[2] ?? "").padEnd(2, "0"));
  const wh = Number(whole) * 1000 + hundredths * 10;

  if (wh > MAX_WH) return { ok: false, error: KWH_ERROR };

  return { ok: true, wh };
}

/** 1 234 567 Вт·ч → «1234,56»: две цифры после запятой, лишнее отбрасывается. */
export function formatWhAsKwh(wh: number): string {
  const hundredths = Math.floor(Math.trunc(wh) / 10);
  const whole = Math.floor(hundredths / 100);
  const rest = String(hundredths % 100).padStart(2, "0");

  return `${whole},${rest}`;
}

/** Подпись поля итогового показания; показания нет — без скобок. */
export function finalReadingLabel(lastReadingWh: number | null | undefined): string {
  const base = "Показание счётчика при снятии, кВт·ч";

  if (typeof lastReadingWh !== "number" || !Number.isFinite(lastReadingWh)) return base;

  return `${base} (последнее полученное показание ${formatWhAsKwh(lastReadingWh)} кВт·ч)`;
}
